export const getUserResourcePath = ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  return `companies/${companyId}/personnel_users/${userId}`;
};

export const userResourceType = "personnel_user" as const;
